// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ff8a0c27","732":"49529e6f","977":"0a87c296"}[chunkId] + ".chunk.js";
};